import { LANG_CODE_PATTERN } from '../config/languages';
import { getStorePathPrefixFromPathname } from '../lib/storefront/storePath';

export const stripLangPrefix = (pathname) => {
    const withoutStore = pathname.replace(/^\/s\/[^/]+\/[^/]+/, '') || '/';
    const stripped = withoutStore.replace(LANG_CODE_PATTERN, '/');
    return stripped === '' ? '/' : stripped;
};

export const getStorePathPrefix = (pathname) => getStorePathPrefixFromPathname(pathname);

export const langPath = (lang, path = '/') => {
    const clean = path.startsWith('/') ? path : `/${path}`;
    if (clean === '/') return `/${lang}`;
    return `/${lang}${clean}`;
};
